import { getUserByID } from '@/redux/actions/userActions';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CompanyTitle from './CompanyTitle';
import TopbarProfile from './TopbarProfile';
import TopbarSidebarButton from './TopbarSidebarButton';

import { useCustomerId } from '@/utils/hooks/useCustomerId';
import { getLocalStorageData, setLocalStorageData } from '@/utils/LocalStorage';
import { TopbarContainer, TopbarLeft, TopbarLogo, TopbarRight } from './BasicTopbarComponents';
import SuperAdminSiteDropdown from './SiteDropdown/SuperAdminSiteDropdown';
import SuperAdminDropdown from './SuperAdminDropdown';

const Topbar = ({ changeMobileSidebarVisibility, changeSidebarVisibility }) => {
  const dispatch = useDispatch();
  const currentUserCustomerID = useSelector((state) => state?.auth?.currentUser?.customerID);
  const siteID = useSelector((state) => state?.site?.currentSite?.key);
  const userID = useSelector((state) => state?.auth?.currentUser?.userID);
  const permissions = useSelector((state) => state?.permissionsStorage?.allModulePermissions?.customers);
  const permissions_all = useSelector((state) => state?.permissionsStorage?.allModulePermissions);
  const scopePermissions = useSelector((state) => state?.permissionsStorage?.scopePermissions);
  const { isLoggedIn } = useSelector((state) => state?.auth);
  const customerOnboarded = useSelector((state) => state?.auth?.currentUser?.customerOnboarded);

  useEffect(() => {
    // Get the selected customer ID from the local storage if exists
    let currentCustomerID = useCustomerId();

    console.log('currentCustomerID', currentCustomerID);

    // If the selected customer ID doesn't exist in the local storage, use the current user's customer ID
    if (!currentCustomerID) {
      currentCustomerID = currentUserCustomerID;
      setLocalStorageData('currentCustomerID', currentUserCustomerID);
    }

    // store logged in user in local storage

    setLocalStorageData('loggedInUserID', userID);

    // If the user ID doesn't exist in the local storage, set it
    const storedUserID = getLocalStorageData('userID');
    if (!storedUserID || storedUserID.length <= 0) {
      // setLocalStorageData('userID', userID)
      setLocalStorageData('userID', userID);
      dispatch(getUserByID(userID));
    } else {
      dispatch(getUserByID(storedUserID));
    }
  }, [currentUserCustomerID, siteID, userID]);

  if (!permissions_all || !scopePermissions) {
    return null;
  }

  return (
    isLoggedIn && (
      <TopbarContainer>
        <TopbarLeft>
          {customerOnboarded === true ? (
            <TopbarSidebarButton
              onClickMobile={changeMobileSidebarVisibility}
              onClickDesktop={changeSidebarVisibility}
            />
          ) : (
            <p style={{ padding: '0px 15px' }}></p>
          )}
          <TopbarLogo to='/tickets' />
        </TopbarLeft>
        <TopbarRight>
          <SuperAdminSiteDropdown />
          {scopePermissions?.isStnUser && permissions?.read ? <SuperAdminDropdown /> : <CompanyTitle />}
          <TopbarProfile />
        </TopbarRight>
      </TopbarContainer>
    )
  );
};

Topbar.propTypes = {
  changeMobileSidebarVisibility: PropTypes.func.isRequired,
  changeSidebarVisibility: PropTypes.func.isRequired,
};

export default Topbar;
